<script lang="ts" setup>
const props = defineProps<{
  isHistoryVisible: boolean;
  isMaximized: boolean;
  subtitle: string;
  title: string;
}>();

const emit = defineEmits<{
  close: [];
  newChat: [];
  showChat: [];
  showHistory: [];
  toggleSize: [];
}>();

const toggleHistoryView = () => {
  if (props.isHistoryVisible) {
    emit('showChat');

    return;
  }

  emit('showHistory');
};

const handleNewChat = () => {
  emit('newChat');
};

const handleToggleSize = () => {
  emit('toggleSize');
};
</script>

<template>
  <div class="flex items-start justify-between gap-14 bg-[linear-gradient(135deg,#1281ff_0%,#0b63d8_100%)] px-20 pb-18 pt-20 text-white">
    <div class="min-w-0">
      <div class="text-18 font-700 leading-26">{{ props.title }}</div>
      <div class="mt-4 truncate text-13 text-white/78 leading-20">
        {{ props.isHistoryVisible ? '选择历史对话继续咨询' : props.subtitle }}
      </div>
    </div>

    <div class="flex flex-shrink-0 items-center gap-8">
      <button
        type="button"
        class="size-34 flex-center cursor-pointer border-0 rounded-full bg-white/16 text-white hover:bg-white/24"
        aria-label="新建聊天"
        title="新建聊天"
        @click="handleNewChat"
      >
        <span class="i-ion:add block size-22"></span>
      </button>
      <button
        type="button"
        class="size-34 flex-center cursor-pointer border-0 rounded-full text-white hover:bg-white/24"
        :class="props.isHistoryVisible ? 'bg-white/28' : 'bg-white/16'"
        :aria-label="props.isHistoryVisible ? '返回 AI 助手聊天' : '查看历史聊天'"
        :title="props.isHistoryVisible ? '返回聊天' : '历史聊天'"
        @click="toggleHistoryView"
      >
        <span
          class="block size-20"
          :class="props.isHistoryVisible ? 'i-ion:chatbubble-ellipses-outline' : 'i-ion:time-outline'"
        >
        </span>
      </button>
      <button
        type="button"
        class="size-34 flex-center cursor-pointer border-0 rounded-full bg-white/16 text-white hover:bg-white/24"
        :aria-label="props.isMaximized ? '恢复 AI 助手默认大小' : '全屏 AI 助手窗口'"
        :aria-pressed="props.isMaximized"
        :title="props.isMaximized ? '恢复' : '全屏'"
        @click="handleToggleSize"
      >
        <span
          class="block size-20"
          :class="props.isMaximized ? 'i-ion:contract-outline' : 'i-ion:expand-outline'"
        >
        </span>
      </button>
      <button
        type="button"
        class="size-34 flex-center cursor-pointer border-0 rounded-full bg-white/16 text-white hover:bg-white/24"
        aria-label="关闭 AI 助手"
        title="关闭"
        @click="emit('close')"
      >
        <span class="i-ion:close block size-22"></span>
      </button>
    </div>
  </div>
</template>
